import React, { PureComponent } from 'react';

type Props = {
  className?: string;
  id?: string;
  name?: string;
  disabled: boolean;
  defaultValue: boolean;
  onChange: (event) => void;
};

class Checkbox extends PureComponent<Props> {
  static defaultProps = {
    defaultValue: false,
    disabled: false,
    className: '',
    id: '',
  };

  state = { checked: this.props.defaultValue };

  render() {
    const { className } = this.props;
    const finalClass = `Checkbox ${className}`.trim();

    const inputAttribs = this.generateInputAttributes();

    return (
      <label className={finalClass}>
        <input className="Checkbox-input" {...inputAttribs} />
      </label>
    );
  }

  handleCheckboxChange = (event) => {
    //Added this if statement for Checkbox.test.js
    this.setState({ checked: event.target.checked });

    if (this.props.onChange) {
      this.props.onChange(event.target.checked);
    }
  };

  generateInputAttributes() {
    const { id, name, disabled } = this.props;

    const inputAttribs = {
      className: 'Checkbox-input',
      type: 'checkbox',
      onChange: this.handleCheckboxChange,
      disabled,
      id: this.props.id,
      name: this.props.name,
      checked: this.props.defaultValue,
    };

    if (id) {
      inputAttribs.id = id;
    }

    if (name) {
      inputAttribs.name = name;
    }

    inputAttribs.checked = this.state.checked;

    return inputAttribs;
  }
}

export default Checkbox;
